const EuroOutlined = ({ ...others }) => {
    return (
      <svg
        {...others}
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle 
          cx="12" 
          cy="12" 
          r="11" 
          stroke="white" 
          strokeWidth="2" 
          fill="none" 
        />
        <g transform="scale(0.8) translate(3, 3)">
          <path 
            stroke="white" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            d="M6 10h9.231M6 14h9.231M18 5.086A5.95 5.95 0 0 0 14.615 4c-3.738 0-6.769 3.582-6.769 8s3.031 8 6.769 8A5.94 5.94 0 0 0 18 18.916" 
          />
        </g>
      </svg>
    );
  };
  
export default EuroOutlined;